import { ReactComponent as Check } from '../../../assets/icons/Check.svg';

import classes from './TextInput.module.scss';

const TextInput = ({ value, validated, error, onChange, ...props }) => {
  return (
    <div className={`${classes.div}`}>
      <input
        {...props}
        className={`${error ? 'input-error' : 'input-text'} ${classes.content} medium-16`}
        value={value}
        onChange={event => onChange(event.target.value)}
      />
      {validated && <Check className={classes.icon} />}
    </div>
  );
};

export default TextInput;
